import type { FC } from 'react';
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface NumberDisplay {
  number: number;
  label: string;
  bigText: boolean;
}

const NumberDisplay: FC<NumberDisplay> = ({
  number = 0,
  label,
  bigText = false,
}) => (
  <Stack
    direction="column"
    spacing={1}
    sx={{
      alignItems: 'center',
    }}
  >
    <Box>
      <Typography
        sx={{
          fontSize: 30,
        }}
      >
        #{number}
      </Typography>
    </Box>
    <Typography
      sx={{
        fontSize: bigText ? 22 : 13,
      }}
    >
      {label}
    </Typography>
  </Stack>
);

export default NumberDisplay;
